import { Predicate, Predicates } from '../../ng/components/validation'
import { Role } from '@contrast-security-inc/base-types'

// this module exists to provide an interface and runtime validation of current-user props
// provided in angularjs templates and react bridge components
export interface CurrentUser {
  name: string
  uid: string
  dateTimeFormat: string
  newUserNotificationPreference: boolean
  setNewUserOnboardingPreferenceCallback?: (arg: boolean) => void
  roles: Role[]
}

export const isCurrentUser: Predicate<CurrentUser> = Predicates.hasShape({
  name: Predicates.isString,
  uid: Predicates.isString,
  dateTimeFormat: Predicates.isString,
  newUserNotificationPreference: Predicates.isBoolean,
  roles: Predicates.isArray
})
